/**
 * Created by forbiz on 2019-02-11.
 */

import 'slick-carousel';

const marketDetail = () => {
	const $window = $(window);
	const $document = $(document);

	const item_slider = () => {
		$('.marketDetail .slider')
			.on('init', function (event, slick) {
				$(this).append('<div class="slick-counter"><span class="current"></span> / <span class="total"></span></div>');
				$('.slick-counter .current').text(slick.currentSlide + 1);
				$('.slick-counter .total').text(slick.slideCount);
			})
			.slick({
				arrows: true,
				autoplay: true,
				autoplaySpeed: 3000, // 5초에 한 번
				cssEase: 'linear',
				// dots: true,
				// appendDots: $('.slick-controller'),
				fade: true,
				infinite: true,
				speed: 500, // 루프 실행 속도
			})
			.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				$('.slick-counter .current').text(nextSlide + 1);
			});

		if ($('.slider__list').length <= 1) {
			$('.slick-controller').hide();
		}
	};

	const tabContents = () => {
		const tabClick = () => {
			$document.on('click', '.tab-menu__list', function (e) {
				const $this = $(this);
				const tab_name = $this.data('tab');
				const $tabContent = $('#' + tab_name);

				$this.addClass('tab-menu__list--on').siblings().removeClass('tab-menu__list--on');
				$tabContent.addClass('tab-contents--current').siblings().removeClass('tab-contents--current');

				e.preventDefault();
			});
		};

		const tabMove = () => {
			$window.on('scroll', function () {
				const _st = $window.scrollTop();
				const num = $('#contents').hasClass('hd__main--pt0') == true ? -70 : -35;

				if (_st + $('#header').height() <= $('.marketDetail__sect.detail').offset().top + num) {
					$('.tab-menu').removeClass('fixed bannerOn bannerOff');
				} else {
					$('.tab-menu').addClass('fixed');
					if ($('#contents').hasClass('hd__main--pt0')) {
						$('.tab-menu').addClass('bannerOff');
					} else {
						$('.tab-menu').addClass('bannerOn');
					}
				}
			});
		};

		const tabContentsInit = () => {
			tabClick();
			//tabMove();
		};

		tabContentsInit();
	};

	const marketDetail_init = () => {
		item_slider();
		tabContents();
	};

	marketDetail_init();
};

export default marketDetail;
